import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter
])

.component('home', homeComponent)
  
.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js